import { formatPrice } from "@/lib/store";
import { PLANS, planValues, useRates } from "@/lib/pricing";

export const InstallmentFields = ({ price, selected, onChange, text, onTextChange, inputClass }) => {
  useRates();
  const value = Number(price) || 0;
  const toggle = (id) => onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  return (
    <div data-testid="product-installments" className="space-y-2 rounded-xl border border-white/10 bg-white/[0.03] p-3.5">
      <p className="text-xs text-zinc-400">Parcelamento (calculado pelas taxas da maquininha, repassadas ao cliente)</p>
      {PLANS.map((pl) => {
        const v = planValues(value, pl);
        return (
          <label key={pl.id} className="flex items-center gap-3 rounded-lg px-1 py-1.5 text-sm text-white">
            <input data-testid={`product-installment-${pl.id}-checkbox`} type="checkbox" checked={selected.includes(pl.id)} onChange={() => toggle(pl.id)} className="h-4 w-4 accent-emerald-400" />
            <span className="flex-1">
              <span className="font-semibold">{pl.n}x</span>{" "}
              <span data-testid={`product-installment-${pl.id}-value`} className="text-zinc-300">
                {value > 0 ? `de ${formatPrice(v.each)} — total parcelado ${formatPrice(v.total)}` : "preencha o preço"}
              </span>
              <span className="block text-[11px] text-zinc-400">taxa {String(v.rate).replace(".", ",")}% repassada</span>
            </span>
          </label>
        );
      })}
      {!selected.length && (
        <input data-testid="product-installment-input" maxLength={60} value={text} onChange={onTextChange}
          placeholder="Ou escreva outra condição (opcional)" className={inputClass} />
      )}
    </div>
  );
};
